import { Amplify } from 'aws-amplify';
import { from, map, Observable, Subject, tap } from 'rxjs';

import { Injectable } from '@angular/core';
import { fetchAuthSession, signIn, SignInInput, SignInOutput, signOut } from '@aws-amplify/auth';
import { cognitoUserPoolsTokenProvider, getCurrentUser } from '@aws-amplify/auth/cognito';
import { AuthConfig, AuthSession, defaultStorage } from '@aws-amplify/core';
import { AwsCredentialIdentity } from '@aws-sdk/types';

import { environment } from '../../environments/environment';

Amplify.configure(environment.amplify);
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
cognitoUserPoolsTokenProvider.setAuthConfig(environment.amplify.Auth as AuthConfig);

@Injectable({
  providedIn: 'root'
})
export class AmplifyService {
  loginStateChanged = new Subject<string | null>();
  #credentials!: AwsCredentialIdentity;

  get credentials(): AwsCredentialIdentity {
    return this.#credentials;
  }
  set credentials(credentials: AwsCredentialIdentity) {
    this.#credentials = credentials;
  }

  get fetchAuthSession(): Observable<AwsCredentialIdentity> {
    return from(fetchAuthSession()).pipe(
      map((res: AuthSession) => ({
        accessKeyId: res.credentials?.accessKeyId as string,
        expiration: res.credentials?.expiration as Date,
        secretAccessKey: res.credentials?.secretAccessKey as string,
        sessionToken: res.credentials?.sessionToken as string,
      })),
    );
  }

  constructor() {
    console.log(JSON.stringify(Amplify.getConfig()));
  }

  public signIn(input: SignInInput): Observable<SignInOutput> {
    return from(signIn(input)).pipe(
      tap(res => {
        if (res.isSignedIn) {
          this.loginStateChanged.next(input.username);
        } else {
          this.loginStateChanged.next(null);
      }
      })
    );
  }

  public signOut(): Observable<void> {
    return from(signOut({ global: true })).pipe(
      tap(() => this.loginStateChanged.next(null)),
    );
  }

  public getCurrentUser(): Promise<any> {
    return getCurrentUser();
  }
}
